import { Directive, HostListener, ElementRef, Input, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { EmbedContextService } from 'src/app/services/embed-context.service';

@Directive({
  selector: 'markdown[linkIntercept], .chat__message[linkIntercept]',
  standalone: true
})
export class LinkInterceptorDirective {
  @Input() allowExternal = false;
  @Input() allowedHosts: string[] = [];

  private embed = inject(EmbedContextService);

  constructor(private router: Router, private el: ElementRef<HTMLElement>, private location: Location) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement | null;
    const a = target?.closest('a');

    if (!a || !this.el.nativeElement.contains(a))
      return;

    const rawHref = a.getAttribute('href') || '';
    if (!rawHref || rawHref.startsWith('#'))
      return;

    const href = this.toAbsoluteURL(rawHref);
    const isExternal = href.origin !== window.location.origin;
    const isTelOrMail = href.protocol === 'tel:' || href.protocol === 'mailto:';

    // HRS-2427/2434: inside the embed, any link click (internal route or the
    // canonical tenant site) must open in a new tab — navigating the iframe would
    // replace the planner/chat with no way back. tel:/mailto: keep default.
    if (this.embed.isEmbed() && !isTelOrMail) {
      event.preventDefault();
      event.stopPropagation();
      window.open(href.href, '_blank', 'noopener,noreferrer');
      return;
    }

    if (isTelOrMail || isExternal)
      return;

    // if (isExternal && !this.allowExternal && !this.isAllowedHost(href)) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   // aquí tu acción (modal, tracking, etc.)
    //   return;
    // }

    if (!isExternal) {
      event.preventDefault();
      event.stopPropagation();
      // El pathname puede traer el base href del despliegue (p.ej. /front/);
      // navigateByUrl espera la ruta sin ese prefijo → se normaliza con Location.
      this.router.navigateByUrl(this.location.normalize(href.pathname) + href.search + href.hash);
    }
  }

  private toAbsoluteURL(raw: string): URL {
    try { return new URL(raw, window.location.origin); }
    catch { return new URL('/', window.location.origin); }
  }

  private isAllowedHost(url: URL): boolean {
    return this.allowedHosts?.some(h => url.hostname.endsWith(h)) ?? false;
  }
}